<template>
    <div class="home-serve container">
        <div class="serve-top">
            <h2>Soul APP媒体概况</h2>
            <h5>ABOUT SOUL</h5>
        </div>
        <div class="serve-contain">
            <p>Soul是基于兴趣图谱和游戏化玩法的产品设计，属于新一代年轻人的虚拟社交网络。成立于2016年，Soul 致力于打造一个“年轻人的社交元宇宙”，最终愿景是“让天下没有孤独的人”。</p>
            <p>在Z世代带来的社交新浪潮下，Soul展现真实、有趣、温暖的社交面貌，不断满足年轻人的精神追求。</p>
            <p>随着SOUL APP的商业化给广大企业客户提供了更多的营销阵地，特别是大量的面向年轻人群体的品牌，都将SOUL视为一个主要的营销路径，相信伴随着SOUL的广告平台的不断完善，会为广大企业带来效果营销的巨大的流量红利。</p>
        </div>
        <img src="../../../assets/images/25005167.png" alt />
    </div>
</template>

<script>
export default {
  name: 'HomeServe'
}
</script>

<style scoped lang="less">
.home-serve {
  flex-direction: column;
  margin: 4px auto;
  padding: 30px;
  background-color: #f3f3f3;
  color: #000;
  .serve-top {
    width: 100%;
    border-bottom: 1px solid #00b7ff;
    padding-left: 48px;
    h5 {
      color: #00b7ff;
    }
  }
  .serve-contain {
    padding: 20px 48px;
    p {
      text-indent: 2em;
      line-height: 2;
    }
  }
}
</style>
